/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<g _fill="none" _stroke="#008579" transform="translate(1 1)"><circle pid="0" cx="6.504" cy="6.504" r="1.125" _fill="#008579" stroke-width=".5"/><path pid="1" d="M6.5 2.69a3.81 3.81 0 1 0 2.643 1.065M6.5 0a6.5 6.5 0 1 0 4.422 1.736M6.5 0a6.5 6.5 0 1 0 4.422 1.736"/><path pid="2" stroke-linecap="square" d="M6.5 0v6.5"/></g>'
  }
})
